import { render, staticRenderFns } from "./VR.vue?vue&type=template&id=1623f2fc&scoped=true&"
import script from "./VR.vue?vue&type=script&lang=js&"
export * from "./VR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1623f2fc",
  null
  
)

export default component.exports